import { useCallback, useEffect, useState } from 'react';
import Changelogs from '../components/Changelogs';
import HashList from '../components/HashList';
import Header from "../components/Header";
import TitleSection from "../components/Title";
import { AppInfo, Changelog, HashInfo } from '../types';
import ChangelogService from '../services/changelog';
import AppService from '../services/app';
import { Helper } from '../helper/helper';

const buildTargetId = 'supar-composer';

const Main = () => {
  const [appInfo, setAppInfo] = useState<AppInfo>();
  const [changelogList, setChangelogList] = useState<Changelog[]>([]);
  const [hashInfoList, setHashInfoList] = useState<HashInfo[]>([]);
  const [isToggled, setIsToggled] = useState<boolean>(false);

  useEffect(() => {
    fetchAppInfo();
  }, []);

  const fetchAppInfo = async () => {
    const data = await AppService.getSuparAppInfo({ buildTargetId: "supar-composer" });
    setAppInfo(data);
  };

  const fetchChangelogList = useCallback(async () => {
    let data = await ChangelogService.getChangelogList({ buildTargetId });

    data = data.filter((changelog) => Helper.getBuildNumber(changelog.version) <= (appInfo?.buildNumber ?? 0));

    setChangelogList(data);
  }, [appInfo]);

  const fetchHashInfoList = useCallback(async () => {
    let data = await AppService.getHashInfoList({ buildTargetId });

    data = data.filter((hashInfo) => Helper.getBuildNumber(hashInfo.version) <= (appInfo?.buildNumber ?? 0));

    setHashInfoList(data);
  }, [appInfo]);

  useEffect(() => {
    if (appInfo) {
      fetchChangelogList();
      fetchHashInfoList();
    }
  }, [appInfo, fetchChangelogList, fetchHashInfoList]);

  return <div className="container">
    <Header appInfo={appInfo} />
    <TitleSection onToggleChange={setIsToggled} />
    {!isToggled ? <Changelogs changelogList={changelogList} /> :
      <HashList hashInfoList={hashInfoList} />}
  </div>
};

export default Main;
